import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { Collapse, Table } from "antd";
import { FormatDateTime, TotalTime } from "../../../utility/format";
import Api from "../../../../services/ServiceApi";
import { BadgePill } from "../../../badge_pill/badge_pill";
import DynamicLabelGroup from "../../../dynamic_label/dynamic_label_group";
import ServiceApi from "../../../../services/ServiceApi";
import { Image } from "antd";
import { FileOutlined } from "@ant-design/icons";
const { Panel } = Collapse;

export default function Jobdetail({
  headerdata,
  Jobdata,
  language,
  factupdate,
}) {
  const [dataTable, setDataTable] = useState([]);
  const loadData = () => {
    ServiceApi.post("JobMaxi/GetProgressITSM", {
      so_id: headerdata.so_id,
      job_id: headerdata.job_id,
      project_id: headerdata.project_id,
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
    })
      .then((response) => {
        setDataTable(response.data.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  useEffect(() => loadData(), []);

  const columns = [
    {
      title: "Type",
      dataIndex: "workInfoType",
      key: "workInfoType",
      render: (text) => <a>{text}</a>,
    },
    {
      title: "Notes",
      dataIndex: "workInfo",
      key: "workInfo",
    },
    {
      title: "Submit Date",
      dataIndex: "submitDateWorklog",
      key: "submitDateWorklog",
    },
    {
      title: "Image",
      dataIndex: "",
      key: "",
      render: (item) => (
        <>
          {item.urlPaths.map((data) => {
            return (
              <div style={{ textAlign: "center" }}>
                {data.includes(".jpg") ||
                data.includes(".png") ||
                data.includes(".svg") ||
                data.includes(".jpeg") ? (
                  <Image width={200} src={data} />
                ) : (
                  <FileOutlined
                    style={{ cursor: "pointer" }}
                    onClick={() => window.location.assign(data)}
                  />
                )}
              </div>
            );
          })}
        </>
      ),
    },
  ];

  const locale = Cookies.get("locale");
  const { result_job_detail, result_assignment, result_total_time } = Jobdata;
  const resultTotalTime = result_total_time[0];
  console.log("resultTotalTime", resultTotalTime);
  return (
    <>
      <Collapse expandIconPosition="right" defaultActiveKey={["1"]}>
        <Panel
          header={
            <>
              <img
                src={Api.absoluteUrl(`/icon/job_maintenance.svg`)}
                alt={factupdate ? language[locale]["job_mainteance"] : null}
                title={factupdate ? language[locale]["job_mainteance"] : null}
              />
              <h4>{factupdate ? language[locale]["job_mainteance"] : null}</h4>
            </>
          }
          key="1"
        >
          <div className="d-flex align-content-md-start flex-wrap w-100">
            {/* ====================== job_detail ====================== */}
            <div className="col col-12 col-sm-6 pb-3">
              <div className="content-box-header">
                <img
                  src={`${Api.absoluteUrl("/icon/job_detail.svg")}`}
                  alt={factupdate ? language[locale]["job_detail"] : null}
                  title={factupdate ? language[locale]["job_detail"] : null}
                />
                <h4>{factupdate ? language[locale]["job_detail"] : null}</h4>
              </div>

              <div className="full-detail-job-des mx-1">
                <div className="row">
                  <span className="col col-4 content-label">
                    {factupdate ? language[locale]["job_no"] : null}
                  </span>
                  <span className="col col-8 content-text">
                    {headerdata && headerdata.job_no ? headerdata.job_no : `-`}
                  </span>
                </div>

                <div className="row">
                  <span className="col col-4 content-label">
                    {factupdate ? language[locale]["so_id"] : null}
                  </span>
                  <span className="col col-8 content-text">
                    {result_job_detail.length > 0 && result_job_detail[0].so_id
                      ? result_job_detail[0].so_id
                      : `-`}
                  </span>
                </div>

                <div className="row">
                  <span className="col col-4 content-label">
                    {factupdate ? language[locale]["so_type"] : null}
                  </span>
                  <span className="col col-8 content-text">
                    {result_job_detail.length > 0 &&
                    result_job_detail[0].job_type_name
                      ? result_job_detail[0].job_type_name
                      : `-`}
                  </span>
                </div>

                <div className="row">
                  <span className="col col-4 content-label">
                    {factupdate ? language[locale]["job_sub_type"] : null}
                  </span>
                  <span className="col col-8 content-text">
                    {result_job_detail.length > 0 &&
                    result_job_detail[0].job_sub_type_name
                      ? result_job_detail[0].job_sub_type_name
                      : `-`}
                  </span>
                </div>

                <div className="row">
                  <span className="col col-4 content-label">
                    {factupdate ? language[locale]["sap_id"] : null}
                  </span>
                  <span className="col col-8 content-text">
                    {result_job_detail.length > 0 && result_job_detail[0].sap_id
                      ? result_job_detail[0].sap_id
                      : `-`}
                  </span>
                </div>

                <div className="row">
                  <span className="col col-4 content-label">
                    {factupdate ? language[locale]["job_sap_type"] : null}
                  </span>
                  <span className="col col-8 content-text">
                    {/* ============= Edit Sap_type_name By Tirapong 31/3/64 =============*/}
                    {result_job_detail.length > 0 &&
                    result_job_detail[0].sap_type_name
                      ? result_job_detail[0].sap_type_name
                      : `-`}
                  </span>
                </div>

                <div className="row">
                  <span className="col col-4 content-label">
                    {factupdate ? language[locale]["workcenter"] : null}
                  </span>
                  <span className="col col-8 content-text">
                    {result_job_detail.length > 0 &&
                    result_job_detail[0].work_center_name
                      ? result_job_detail[0].work_center_name
                      : `-`}
                  </span>
                </div>

                <div className="row">
                  <span className="col col-4 content-label">
                    {factupdate ? language[locale]["work_center_code"] : null}
                  </span>
                  <span className="col col-8 content-text">
                    {result_job_detail.length > 0 &&
                    result_job_detail[0].work_center_code
                      ? result_job_detail[0].work_center_code
                      : `-`}
                  </span>
                </div>

                <div className="row">
                  <span className="col col-4 content-label">
                    {factupdate ? language[locale]["area_code"] : null}
                  </span>
                  <span className="col col-8 content-text">
                    {result_job_detail.length > 0 &&
                    result_job_detail[0].area_code
                      ? result_job_detail[0].area_code
                      : `-`}
                  </span>
                </div>

                <div className="row">
                  <span className="col col-4 content-label">
                    {factupdate ? language[locale]["subcenter"] : null}
                  </span>
                  <span className="col col-8 content-text">
                    {result_job_detail.length > 0 &&
                    result_job_detail[0].sub_center_code
                      ? result_job_detail[0].sub_center_code
                      : `-`}
                  </span>
                </div>

                <div className="row">
                  <span className="col col-4 content-label">
                    {factupdate ? "Impact" : null}
                  </span>
                  <span className="col col-8 content-text">
                    {headerdata.impact ? headerdata.impact : `-`}
                  </span>
                </div>
              </div>
            </div>
            {/* ====================== job_assignment ====================== */}
            <div className="col col-12 col-sm-6 pb-3">
              <div className="content-box-header">
                <img
                  src={`${Api.absoluteUrl(
                    "/icon/bbtec/body/Job-Assignment.svg"
                  )}`}
                  alt={factupdate ? language[locale]["job_assignment"] : null}
                  title={factupdate ? language[locale]["job_assignment"] : null}
                />
                <h4>
                  {factupdate ? language[locale]["job_assignment"] : null}
                </h4>
              </div>
              <div className="full-detail-job-des mx-1">
                {result_assignment?.map((data, index) => {
                  if (data.subflag === "C") {
                    return (
                      <>
                        <div key={`assign_mm_${index}`}>
                          <div className="row">
                            <span className="col col-4 content-label">
                              {factupdate
                                ? language[locale]["assign_mm"]
                                : null}
                            </span>
                            <span className="col col-8 content-text">
                              {data.assignjob_emp_name
                                ? data.assignjob_emp_name
                                : `-`}
                            </span>
                          </div>
                          <div className="row">
                            <span className="col col-4 content-label">
                              {factupdate
                                ? language[locale]["ackjob_mm"]
                                : null}
                            </span>
                            <span className="col col-8 content-text">
                              {data.actjob_emp_name
                                ? data.actjob_emp_name
                                : `-`}
                            </span>
                          </div>
                          <div className="row">
                            <span className="col col-4 content-label">
                              {null}
                            </span>
                            <span className="col col-8 content-text">
                              {data.emp_company_name
                                ? data.emp_company_name
                                : `-`}
                            </span>
                          </div>
                          <div className="row">
                            <span className="col col-4 content-label">
                              {null}
                            </span>
                            <span className="col col-8 content-text">
                              {data.emp_tel ? data.emp_tel : `-`}
                            </span>
                          </div>
                        </div>
                      </>
                    );
                  }
                })}
                {result_assignment.map((data, index) => {
                  if (data.subflag === "O") {
                    return (
                      <>
                        <div key={`assign_sub_${index}`}>
                          <div className="row">
                            <span className="col col-4 content-label">
                              {factupdate
                                ? language[locale]["assign_sub"]
                                : null}
                            </span>
                            <span className="col col-8 content-text">
                              {data.assignjob_emp_name
                                ? data.assignjob_emp_name
                                : `-`}
                            </span>
                          </div>
                          <div className="row">
                            <span className="col col-4 content-label">
                              {factupdate
                                ? language[locale]["ackjob_sub"]
                                : null}
                            </span>
                            <span className="col col-8 content-text">
                              {data.actjob_emp_name
                                ? data.actjob_emp_name
                                : `-`}
                            </span>
                          </div>
                          <div className="row">
                            <span className="col col-4 content-label">
                              {null}
                            </span>
                            <span className="col col-8 content-text">
                              {data.emp_company_name
                                ? data.emp_company_name
                                : `-`}
                            </span>
                          </div>
                          <div className="row">
                            <span className="col col-4 content-label">
                              {null}
                            </span>
                            <span className="col col-8 content-text">
                              {data.emp_tel ? data.emp_tel : `-`}
                            </span>
                          </div>
                        </div>
                      </>
                    );
                  }
                })}
                {result_assignment && result_assignment.length === 0 ? (
                  <span>ไม่พบข้อมูลการมอบหมายงาน</span>
                ) : null}
              </div>
            </div>

            {/* ====================== problem_detail_#1 ====================== */}
            <div className="col col-12 col-sm-6 pb-3">
              <div className="content-box-header">
                <img
                  src={`${Api.absoluteUrl("/icon/problem_icon.svg")}`}
                  alt={factupdate ? language[locale]["problem_detail"] : null}
                  title={factupdate ? language[locale]["problem_detail"] : null}
                />
                <h4>
                  {factupdate ? language[locale]["problem_detail"] : null}
                </h4>
              </div>
              <div className="full-detail-job-des mx-1">
                <div className="row">
                  <span className="col col-4 content-label">
                    {factupdate ? language[locale]["date_start"] : null}
                  </span>
                  <span className="col col-8 content-text">
                    {result_job_detail.length > 0 &&
                    result_job_detail[0].first_start_date ? (
                      <FormatDateTime
                        text={result_job_detail[0].first_start_date}
                      ></FormatDateTime>
                    ) : (
                      `-`
                    )}
                  </span>
                </div>
                <div className="row">
                  <span className="col col-4 content-label">Finish Date</span>
                  <span className="col col-8 content-text">
                    <FormatDateTime text={resultTotalTime.v_last_date} />
                    {/* <FormatDateTime text={resultTotalTime.v_last_date} /> */}
                    {/* {moment(resultTotalTime.v_last_date).format(
                      "DD/MM/YYYY HH:mm:ss"
                    )} */}
                  </span>
                </div>
                <div className="row">
                  <span className="col col-4 content-label">Total Time</span>
                  <span className="col col-8 content-text">
                    {/* {resultTotalTime.a} */}
                    <TotalTime
                      days={resultTotalTime.days}
                      hour={resultTotalTime.hours}
                      min={resultTotalTime.min}
                    />
                  </span>
                </div>
                <div className="row">
                  <span className="col col-4 content-label">
                    {factupdate ? language[locale]["inform_name"] : null}
                  </span>
                  <span className="col col-8 content-text">
                    {result_job_detail.length > 0 &&
                    result_job_detail[0].emp_name
                      ? result_job_detail[0].emp_name
                      : `-`}
                  </span>
                </div>
                <div className="row">
                  <span className="col col-4 content-label">
                    {factupdate ? language[locale]["job_detail"] : null}
                  </span>
                  <span className="col col-8 content-text">
                    {result_job_detail.length > 0 &&
                    result_job_detail[0].problem_detail
                      ? result_job_detail[0].problem_detail
                      : `-`}
                  </span>
                </div>
                <div className="row">
                  <span className="col col-4 content-label">
                    {factupdate ? language[locale]["remark"] : null}
                  </span>
                  <span className="col col-8 content-text">
                    {result_job_detail.length > 0 &&
                    result_job_detail[0].inform_remark
                      ? result_job_detail[0].inform_remark
                      : `-`}
                  </span>
                </div>
              </div>
            </div>
            {/* ====================== problem_detail_#2 ====================== */}
            <div className="col col-12 col-sm-6 pb-3">
              <div className="content-box-header">
                <h4>{null}</h4>
              </div>
              <div className="full-detail-job-des mx-1">
                <div className="row">
                  <span className="col col-4 content-label">
                    {factupdate ? language[locale]["sla_level"] : null}
                  </span>
                  <span className="col col-8 content-text">
                    {result_job_detail.length > 0 &&
                    result_job_detail[0].sla_name
                      ? result_job_detail[0].sla_name
                      : `-`}
                  </span>
                </div>
                <div className="row">
                  <span className="col col-4 content-label">
                    {factupdate ? language[locale]["standard_day"] : null}
                  </span>
                  <span className="col col-8 content-text">
                    {result_job_detail.length > 0 &&
                    result_job_detail[0].sla_time_day
                      ? result_job_detail[0].sla_time_day
                      : `-`}
                  </span>
                </div>
                <div className="row">
                  <span className="col col-4 content-label">
                    {factupdate ? language[locale]["Standard Hour"] : null}
                  </span>
                  <span className="col col-8 content-text">
                    {result_job_detail.length > 0 &&
                    result_job_detail[0].sla_time_hour
                      ? result_job_detail[0].sla_time_hour
                      : `-`}
                  </span>
                </div>
                <div className="row">
                  <span className="col col-4 content-label">
                    {factupdate ? language[locale]["standard_minute"] : null}
                  </span>
                  <span className="col col-8 content-text">
                    {result_job_detail.length > 0 &&
                    result_job_detail[0].sla_time_min
                      ? result_job_detail[0].sla_time_min
                      : `-`}
                  </span>
                </div>
                <div className="row">
                  <span className="col col-4 content-label">
                    {factupdate ? language[locale]["priority"] : null}
                  </span>
                  <span className="col col-8 content-text">
                    {result_job_detail.length > 0 &&
                    result_job_detail[0].priority_name ? (
                      <BadgePill
                        bgColor={result_job_detail[0].priority_status_bgcolor}
                        color={result_job_detail[0].priority_status_color}
                        text={result_job_detail[0].priority_name}
                      ></BadgePill>
                    ) : (
                      `-`
                    )}
                  </span>
                </div>
                <div className="row">
                  <span className="col col-4 content-label">
                    {factupdate ? language[locale]["job_status"] : null}
                  </span>
                  <span className="col col-8 content-text">
                    {headerdata ? headerdata.job_status_name : `-`}
                  </span>
                </div>
              </div>
            </div>

            <div className="col col-12 pb-3">
              <Table
                columns={columns}
                dataSource={dataTable}
                pagination={false}
              />
            </div>

            {/* ====================== Impacttext ====================== */}
            {result_job_detail.length > 0 &&
            result_job_detail[0] &&
            result_job_detail[0]?.data_dynamic &&
            result_job_detail[0]?.data_dynamic !== "{}" ? (
              <>
                <DynamicLabelGroup
                  factupdate={factupdate}
                  language={language}
                  locale={locale}
                  localeKey={"impact_group_id"}
                  data={
                    result_job_detail[0]?.data_dynamic &&
                    result_job_detail[0]?.data_dynamic !== "{}"
                      ? result_job_detail[0]?.data_dynamic
                      : null
                  }
                  groupHeader={true}
                  groupHeaderIcon={`${Api.absoluteUrl(
                    "/icon/bbtec/body/Additional-data.svg"
                  )}`}
                ></DynamicLabelGroup>
              </>
            ) : null}
            {/* ====================== employment ====================== */}
            <div className="col col-12 col-sm-6 pb-3">
              <div className="content-box-header">
                <img
                  src={`${Api.absoluteUrl("/icon/bbtec/body/employment.svg")}`}
                  alt={factupdate ? language[locale]["employment"] : null}
                  title={factupdate ? language[locale]["employment"] : null}
                />
                <h4>{factupdate ? language[locale]["employment"] : null}</h4>
              </div>
              <div className="full-detail-job-des mx-1">
                <div className="row">
                  <span className="col col-4 content-label">
                    {factupdate ? language[locale]["employment"] : null}
                  </span>
                  <span className="col col-8 content-text">
                    {result_job_detail.length > 0 &&
                    result_job_detail[0].employment_flag
                      ? result_job_detail[0].employment_flag
                      : `-`}
                  </span>
                </div>
                <div className="row">
                  <span className="col col-4 content-label">
                    {factupdate ? language[locale]["employment_type"] : null}
                  </span>
                  <span className="col col-8 content-text">
                    {result_job_detail.length > 0 &&
                    result_job_detail[0].employment_type
                      ? result_job_detail[0].employment_type
                      : `-`}
                  </span>
                </div>
                <div className="row">
                  <span className="col col-4 content-label">
                    {factupdate ? language[locale]["remark"] : null}
                  </span>
                  <span className="col col-8 content-text">
                    {result_job_detail.length > 0 &&
                    result_job_detail[0].employment_remark
                      ? result_job_detail[0].employment_remark
                      : `-`}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Panel>
      </Collapse>
    </>
  );
}
